export class ProductRequest {

    id: string;
    counter_id: number;
    warehouse_id: number;
    doc_date: string;
    need_date: string;
    desc: string;
    status: string;
    created_by: string;
    updated_by: string;
    po_auto: string;
    action:string;
    proposal_number:string;
    proposal_desc:string;
    proposal_start_date:string;
    proposal_end_date:string;

    constructor(model?) {
        model = model || {};
        this.id = model.id || null;
        this.counter_id = model.counter_id || 0;
        this.warehouse_id = model.warehouse_id || 0;
        this.doc_date = model.doc_date || null;
        this.need_date = model.need_date || null;
        this.desc = model.desc || null;
        this.status = model.status || '0';
        this.created_by = model.created_by || null;
        this.updated_by = model.updated_by || null;
        this.po_auto = model.po_auto || 'N';
        this.action = model.action || 'detail';
        this.proposal_number = model.proposal_number || '';
        this.proposal_desc = model.proposal_desc || '';
        this.proposal_start_date = model.proposal_start_date || '';
        this.proposal_end_date = model.proposal_end_date || '';
    }
}

export class ProductRequestDetail {

    product_request_id: string[];
    product_id: string[];
    qty: number[];
    unit: string[];
    qty_receipt: number[];
    product_type:string[];
    source:string[];
    price:string[];

    constructor(model?) {
        model = model || {};
        this.product_request_id = model.product_request_id || [];
        this.product_id = model.product_id || [];
        this.qty = model.qty || [];
        this.unit = model.unit || [];
        this.qty_receipt = model.qty_receipt || [];
        this.product_type = model.product_type || [];
        this.source = model.source || [];
        this.price = model.price || [];
    }
}